// Client/src/utils/stateLrs/registry.js
// Per-state LRS adapter registry. Add a state by writing its adapter module
// (same interface as aldot.js) and registering it here — no UI changes needed.
import { aldotAdapter } from './aldot';

const ADAPTERS = { AL: aldotAdapter };

export const DEFAULT_LRS_STATE = 'AL';

export function getLrsAdapter(stateCode) {
  return ADAPTERS[stateCode] ?? null;
}
